// 关于项目中的金额单位转换
export function conversionAmount(money = 0) {
    if (!money && money != 0) return "-";
    return money / 100 + "元";
}
